import React from 'react';
import Rating from 'react-rating';

class StarRating extends React.Component {
  constructor(props) {
    super(props);
    this.handleReset = this.handleReset.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleReset(event) {
    let questionData = this.props.questionData;
    if (this.props.onChange) this.props.onChange(null, questionData, "star_rating");
  }

  handleOnChange(value) {
    let questionData = this.props.questionData;
    if (this.props.onChange) this.props.onChange(value, questionData, "star_rating");
  }

  render() {
    let questionData = this.props.questionData;
    let cancelImgStyle = {
      marginRight: '8px',
      paddingTop: '1px',
      cursor: 'pointer'
    }

    let resetGrayImg = "/assets/new-star-rating/reset-gray.svg";
    let resetRedImg = "/assets/new-star-rating/reset-red.svg";
    let emptySymbol = `/assets/new-star-rating/${questionData.rating_style}-unfilled.svg`;
    let fullSymbol = `/assets/new-star-rating/${questionData.rating_style}-filled.svg`;
    return(
      <div>
        <img
          src={resetGrayImg}
          height="15"
          width="15"
          onClick={this.handleReset}
          onMouseOver={e => (e.currentTarget.src = resetRedImg)}
          onMouseOut={e => (e.currentTarget.src = resetGrayImg)}
          style={cancelImgStyle}
        />
        <Rating
          onChange={this.handleOnChange}
          initialRating={this.props.value}
          value={this.props.value}
          emptySymbol={<img src={emptySymbol} className="icon mrhalf" height="15" width="15" />}
          fullSymbol={<img src={fullSymbol} className="icon mrhalf" height="15" width="15" />}
        />
      </div>
    )
  }
}

export default StarRating;
